import React from "react";
import { EditIcon, deleteIcon } from "../../../../assets/svg";

export const templateTableColumns = (
  handleEdit,
  handleDelete,
  isTemplateModificationAllowed
) => {
  return [
    {
      title: "Template Name",
      dataIndex: "name",
      key: "name",
      sorter: false,
      width: 200,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: false,
      width: 200,
    },
    {
      title: "Created By",
      dataIndex: "user",
      key: "user",
      sorter: false,
      width: 200,
      render: (text, record) => {
        return record?.showAs === "default" ? (
          "Default"
        ) : (
          <span>{record?.user?.name}</span>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      sorter: false,
      width: 200,
      render: (text, record) => {
        const showActions =
          (isTemplateModificationAllowed && record?.showAs === "default") ||
          (!isTemplateModificationAllowed && record?.showAs !== "default");
        return (
          showActions && (
            <div className="action-buttons">
              <span className="icon" onClick={() => handleEdit(record)}>
                <EditIcon />
              </span>
              <span className="icon" onClick={() => handleDelete(record)}>
                {deleteIcon}
              </span>
            </div>
          )
        );
      },
    },
  ];
};
